import { JsonValueSchema } from 'notable-common';
import { z } from 'zod';
export var FlowRunSignalStatus;
(function (FlowRunSignalStatus) {
    FlowRunSignalStatus["Waiting"] = "Waiting";
    FlowRunSignalStatus["Received"] = "Received";
    FlowRunSignalStatus["TimedOut"] = "TimedOut";
})(FlowRunSignalStatus || (FlowRunSignalStatus = {}));
/** A flow run signal as flow-api serves it: `Date` columns are ISO strings. */
export const FlowRunSignalResponseSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime({ offset: true }),
    updated: z.iso.datetime({ offset: true }),
    flowRunId: z.uuid(),
    workflowId: z.string(),
    workflowRunId: z.string(),
    blockId: z.string(),
    signalName: z.string(),
    status: z.enum(FlowRunSignalStatus),
    responsePayload: z.record(z.string(), JsonValueSchema).nullable(),
});
//# sourceMappingURL=signal.js.map